/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import DatePickerDisplay from './components/date_picker_display';

document.addEventListener('react-components:load', () => {
  const allDatePickerElements = document.querySelectorAll('.has-datepicker');

  var count = 0;
  allDatePickerElements.forEach(function(el) {
    var inputName = el.name;
    var inputValue = el.value;
    var inputEl = document.createElement('div');

    inputEl.id = `react-datepicker-${count}`;
    el.parentNode.insertBefore(inputEl, el);
    el.parentNode.removeChild(el);

    if (inputValue != '') {
      inputValue = moment(inputValue, 'D/M/Y');
    } else {
      inputValue = null;
    }

    ReactDOM.render(
      <DatePickerDisplay 
        showTimeSelect={false}
        placeholderText=""
        startDate={inputValue}
        className="form-control validate-date"
        name={inputName}
        dateFormat="D/M/Y"
      />,
     inputEl
    )
  });
})
